module.exports = __webpack_public_path__ + "93c2efaab59c06044a36fed5f3834654.jpg";